// extracted by mini-css-extract-plugin
export default {"frame":"PdfRenderer_frame__NZor7"};